import { render, staticRenderFns } from "./WarehouseHome.vue?vue&type=template&id=4a05862e&"
import script from "./WarehouseHome.vue?vue&type=script&lang=js&"
export * from "./WarehouseHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports